export interface Recipient {
  email: string;
  first_name: string;
  last_name: string;
}

export class NewsletterSubscription {
  public recipient: Recipient;
}